import TimeMe from 'timeme.js';
import { postSU } from './apiRequester';


const adminTimeReportQuantum = 3; // 3sec
TimeMe.initialize({
  currentPageName: 'app',
  idleTimeoutInSeconds: 60
});

let reportedTime = 0;

const handleAdminTimeUpdate = function () {
  const time = TimeMe.getTimeOnCurrentPageInSeconds(); // rounding to 'seconds'
  const diff = time - reportedTime;
  // console.log(time);
  if (diff > adminTimeReportQuantum) {
    reportedTime += diff;
    postSU('/admin/time', { time: diff });
  }
};

setInterval(handleAdminTimeUpdate, 1000);

export const resetTimer = () => {
  reportedTime = TimeMe.getTimeOnCurrentPageInSeconds();
};



// WEBPACK FOOTER //
// ./src/utils/timetracker.js